import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowPrev = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.7852 7L9.78516 12L14.7852 17",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowPrev;
